/**
 * Orbit Design System — Tailwind preset
 * Maps Tailwind theme.extend to CSS variables from @imj_media/orbit-tokens.
 * Single source for theme keys shared with @imj_media/ui and consuming apps.
 *
 * Usage: presets: [import("@imj_media/orbit-tokens/tailwind/preset").default]
 * or: presets: [require("@imj_media/orbit-tokens/tailwind/preset")]
 */
import { buildOrbitTailwindThemeExtend } from "./buildThemeExtend";

const preset = {
  theme: {
    extend: buildOrbitTailwindThemeExtend(),
  },
};

export default preset;
